/** Shared dimensions for dashboard-style right rails (community / marketplace). */
export const RIGHT_RAIL_WIDTH = 300;
